"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setApiKey = exports.getApiKey = exports.setCustomerToken = exports.getCustomerToken = void 0;

var _util = require("lodash/util");

var _lang = require("lodash/lang");

var vault = function vault() {};

vault.token = false;

vault.getCustomerToken = function () {
  return this.token;
};

vault.setCustomerToken = function (token) {
  this.token = token;
};

var getCustomerToken = function getCustomerToken() {
  return vault.getCustomerToken();
};

exports.getCustomerToken = getCustomerToken;

var setCustomerToken = function setCustomerToken(action) {
  if (!(0, _lang.isObject)(action)) return;
  vault.setCustomerToken((0, _util.defaultTo)(action.customerToken, false));
};

exports.setCustomerToken = setCustomerToken;
vault.apiKey = '';

vault.getApiKey = function () {
  return this.apiKey;
};

vault.setApiKey = function (apiKey) {
  this.apiKey = apiKey;
};

var getApiKey = function getApiKey() {
  if (!vault.getApiKey()) throw Error('ERROR: No apiKey provided');
  return vault.getApiKey();
};

exports.getApiKey = getApiKey;

var setApiKey = function setApiKey(apiKey) {
  vault.setApiKey(apiKey);
};

exports.setApiKey = setApiKey;